import { Observable } from 'rxjs';

import { IEpTableDataDto, IEpTableSettingsDto, IGetTableDataCriteria, IGetTableSettingsCriteria } from './table';

export abstract class EpDataHttpService {
	abstract getTableSettings(criteria: IGetTableSettingsCriteria): Observable<IEpTableSettingsDto>;
	abstract getTableData<T = any>(criteria: IGetTableDataCriteria): Observable<IEpTableDataDto<T>>;

	abstract getEpSelectValues(params: IGetEpSelectValuesParams): Observable<IGetEpSelectValuesResult>;
	abstract getEpLookupValues(params: IGetEpLookupValuesParams): Observable<IGetEpLookupValuesResult>;
}

export interface IGetEpLookupValuesParams {
	subcatId: number;
	extParamId: number;
	textFilter?: string;
	taskId?: number;
	take?: number;
	skip?: number;
	tableEpColumnId?: number;
	parentExtParamId?: number;
	parentExtParamId2?: number;
	parentColumnId?: number;
	parentColumnId2?: number;
	parentExtParamValues?: any[];
	parentExtParamValuesStr?: string;
	parentExtParamValues2?: any[];
	valuesFilter?: any[];
	selectedValues?: any[];
}

export type IGetEpLookupValuesResult = {
	text: string;
	value: string;
}[];

export interface IGetEpSelectValuesParams {
	subcatId: number;
	extParamId: number;
	text?: string;
	skip?: number;
	take?: number;
	taskId?: number;
	isFromSubcatTasks?: true;
	columnId?: number;
	parentColumnId?: number;
	parentColumnId2?: number;
	parentId?: number;
	parentId2?: number;
	parentValues?: any[];
	parentValues2?: any[];
	otherValuesTableJson?: string;
	sourceBlockId?: number;
}

export interface IGetEpSelectValuesResult {
	data: {
		text: string;
		value: string;
	}[];
	total: number;
	group?: any[];
	aggregates?: any;
}
